import { render, staticRenderFns } from "./CoreEPICPolicyHeader.html?vue&type=template&id=2d5dea9d&external"
import script from "./CoreEPICPolicyHeader.vue?vue&type=script&lang=js"
export * from "./CoreEPICPolicyHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports